<tlk-card class="arch-alignment-card">
	<div tlkCardContent>
		<div class="arch-alignment-content">
			<span class="arch-alignment-label">{{ 'ArchAlignment.Label' | translate }}</span>
			<div class="arch-alignment-toggles">
				<tlk-slide-toggle
					[id]="'arch-alignment-upper-toggle'"
					name="archAlignmentUpper"
					labelPosition="right"
					[formControl]="upperJawControl"
					[isDisabled]="isReadOnly$ | async"
				>
					{{ 'ArchAlignment.UpperArch' | translate }}
				</tlk-slide-toggle>
				<tlk-slide-toggle
					[id]="'arch-alignment-lower-toggle'"
					name="archAlignmentLower"
					labelPosition="right"
					[formControl]="lowerJawControl"
					[isDisabled]="isReadOnly$ | async"
				>
					{{ 'ArchAlignment.LowerArch' | translate }}
				</tlk-slide-toggle>
			</div>
		</div>
	</div>
</tlk-card>
